import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

@Injectable({ providedIn: 'root' })
export class PupCreditService {
  constructor(private apiService: ApiService) {}

  /**
   * Generates the monthly "Generate PUP Credit" sheet (ports easypick-ui behaviour).
   * @param from 1-12 (From month)
   * @param to 1-12 (To month)
   * @param year e.g. 2026
   * @param includeLockerTotalBookings adds the "Locker Total Bookings" sheet
   * @param locationName optional, restrict to a single location by name (else all)
   * @param excludeClosed optional, drop locations whose name starts with "(CLOSED) "
   */
  generatePupCredit(
    from: number,
    to: number,
    year: number,
    includeLockerTotalBookings: boolean,
    locationName: string | null = null,
    excludeClosed = false,
    sortByCountry = false,
    separateDailyMonthly = false
  ): Observable<any> {
    let endpoint = `get-pup-credit?from=${from}&to=${to}&year=${year}`;
    if (includeLockerTotalBookings) {
      endpoint += '&includeLockerTotalBookings=true';
    }
    if (locationName != null && locationName.length) {
      endpoint += `&locationName=${encodeURIComponent(locationName)}`;
    }
    if (excludeClosed) {
      endpoint += '&excludeClosed=true';
    }
    if (sortByCountry) {
      endpoint += '&sortByCountry=true';
    }
    if (separateDailyMonthly) {
      endpoint += '&separateDailyMonthly=true';
    }
    return this.apiService.get(endpoint);
  }

  /**
   * Exports PUP credit balances as of the given date (YYYY-MM-DD).
   * @param locationName optional, restrict to a single location by name (else all)
   * @param excludeClosed optional, drop locations whose name starts with "(CLOSED) "
   */
  exportCreditAtDate(
    date: string,
    locationName: string | null = null,
    excludeClosed = false,
    sortByCountry = false
  ): Observable<any> {
    let endpoint = `get-pup-credit-at-date?date=${date}`;
    if (locationName != null && locationName.length) {
      endpoint += `&locationName=${encodeURIComponent(locationName)}`;
    }
    if (excludeClosed) {
      endpoint += '&excludeClosed=true';
    }
    if (sortByCountry) {
      endpoint += '&sortByCountry=true';
    }
    return this.apiService.get(endpoint);
  }
}
